import { root, subdomains } from "@/common/consts";
import LanguageSwitcher from "@/components/LanguageSwitcher/LanguageSwitcher.vue";

export default {
    components: {
        LanguageSwitcher
    },
    data() {
        return {
            languages: [
                { name: "English", url: `${root.WWW}/` },
                { name: "Español", url: `${root.ES}/` }
            ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/SpanishHeader/SpanishHeader.js